import { Calendar } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';

export const PeriodSelectControl = ({
  period,
  onPeriodChange,
  periodOptions,
  customStartDate,
  customEndDate,
  onCustomStartChange,
  onCustomEndChange,
  selectTriggerClassName = 'w-40 bg-white border-slate-200',
  customRangeClassName = 'flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2',
  inputClassName = 'h-9 w-[150px] border-slate-200',
  customRangeMode = 'inline',
  customTriggerLabel = 'Datas',
  customTriggerClassName = 'h-9 rounded-lg border-slate-200 bg-white px-2 text-[11px]',
  selectTestId = 'period-selector',
  customRangeTestId = 'custom-period-range',
  customStartTestId = 'custom-start-date-input',
  customEndTestId = 'custom-end-date-input',
  customTriggerTestId = 'custom-period-trigger',
}) => (
  <>
    <Select value={period} onValueChange={onPeriodChange}>
      <SelectTrigger className={cn('bg-white border-slate-200', selectTriggerClassName)} data-testid={selectTestId}>
        <Calendar className="mr-2 h-4 w-4 text-slate-400" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {periodOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>

    {period === 'custom' && (
      customRangeMode === 'popover' ? (
        <Popover>
          <PopoverTrigger asChild>
            <Button type="button" variant="outline" className={cn('h-9 rounded-lg border-slate-200 bg-white px-2 text-[11px]', customTriggerClassName)} data-testid={customTriggerTestId}>
              {customTriggerLabel}
            </Button>
          </PopoverTrigger>
          <PopoverContent align="start" className="w-[320px] space-y-3" data-testid={customRangeTestId}>
            <div>
              <p className="text-[11px] text-muted-foreground">Data inicial</p>
              <Input
                type="date"
                value={customStartDate}
                onChange={(event) => onCustomStartChange(event.target.value)}
                className={cn('mt-1 h-9 w-full border-slate-200', inputClassName)}
                data-testid={customStartTestId}
              />
            </div>
            <div>
              <p className="text-[11px] text-muted-foreground">Data final</p>
              <Input
                type="date"
                value={customEndDate}
                onChange={(event) => onCustomEndChange(event.target.value)}
                className={cn('mt-1 h-9 w-full border-slate-200', inputClassName)}
                data-testid={customEndTestId}
              />
            </div>
          </PopoverContent>
        </Popover>
      ) : (
        <div className={cn('flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2', customRangeClassName)} data-testid={customRangeTestId}>
          <Input
            type="date"
            value={customStartDate}
            onChange={(event) => onCustomStartChange(event.target.value)}
            className={cn('h-9 w-[150px] border-slate-200', inputClassName)}
            data-testid={customStartTestId}
          />
          <Input
            type="date"
            value={customEndDate}
            onChange={(event) => onCustomEndChange(event.target.value)}
            className={cn('h-9 w-[150px] border-slate-200', inputClassName)}
            data-testid={customEndTestId}
          />
        </div>
      )
    )}
  </>
);